import React from 'react'
import Bread from 'react-breadcrumbs'
import PropTypes from 'prop-types'

const Breadcrumb = props => (
  <div className="page-bar">
    <Bread
      wrapperElement="ul"
      itemElement="li"
      wrapperClass="page-breadcrumb"
      separator="&nbsp;/&nbsp;"
      routes={props.data.routes}
      params={props.data.params}
    />
  </div>
)

Breadcrumb.defaultProps = {
  data: {
    routes: [],
    params: {},
  },
}

Breadcrumb.propTypes = {
  data: PropTypes.shape({
    routes: PropTypes.array.isRequired,
    params: PropTypes.shape({

    }).isRequired,
  }).isRequired,
}

export default Breadcrumb
